module.exports = __webpack_public_path__ + "img/Photo_4__Welland_Canal_2009_20_207_Winter_Lay_Up_PC.e67130de.jpg";